// Product Prices List functionality - Move dialogs to body

(function() {
  'use strict';

  function moveDialogsToBody(productId) {
    if (!productId) return;

    // Move prices dialog
    var pricesDialog = document.querySelector('[data-dialog-type="prices"][data-product-id="' + productId + '"]');
    if (pricesDialog && pricesDialog.parentNode !== document.body) {
      document.body.appendChild(pricesDialog);
    }

    // Move add price dialog
    var addPriceDialog = document.querySelector('[data-dialog-type="add-price"][data-product-id="' + productId + '"]');
    if (addPriceDialog && addPriceDialog.parentNode !== document.body) {
      document.body.appendChild(addPriceDialog);
    }
  }

  // Initialize for all product price dialogs
  function initProductPriceDialogs() {
    // Find all product IDs from data attributes
    var productDialogs = document.querySelectorAll('[data-product-id][data-dialog-type]');
    var productIds = new Set();
    
    productDialogs.forEach(function(dialog) {
      var productId = dialog.getAttribute('data-product-id');
      if (productId) {
        productIds.add(productId);
      }
    });

    // Move dialogs for each product
    productIds.forEach(function(productId) {
      moveDialogsToBody(productId);
    });
  }

  // Initial move
  setTimeout(initProductPriceDialogs, 200);

  // Move dialogs after Livewire updates
  function setupLivewireHooks() {
    if (typeof Livewire !== 'undefined') {
      document.addEventListener('livewire:init', function() {
        if (Livewire.hook) {
          Livewire.hook('morph.updated', function() {
            setTimeout(initProductPriceDialogs, 50);
          });
        }
      });
    } else {
      // Retry after a short delay
      setTimeout(setupLivewireHooks, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initProductPriceDialogs, 200);
      setupLivewireHooks();
    });
  } else {
    setupLivewireHooks();
  }

  // Re-initialize on Livewire navigation
  document.addEventListener('livewire:navigated', function() {
    setTimeout(initProductPriceDialogs, 200);
  });
})();

